export default {
  BaseFormInput: () => import('./BaseFormInput'),
  BaseFormPassword: () => import('./BaseFormPassword'),
  BaseFormTextarea: () => import('./BaseFormTextarea'),
  BaseFormCheckbox: () => import('./BaseFormCheckbox'),
  BaseFormCheckboxExpandable: () => import('./checkboxexpandable/BaseFormCheckboxExpandable'),
  BaseFormRadioButton: () => import('./BaseFormRadioButton'),
  BaseFormSelect: () => import('./BaseFormSelect'),
  BaseFormDatepicker: () => import('./BaseFormDatepicker'),
  BaseFormNumberInput: () => import('./BaseFormNumberInput'),
  BaseFormPaymentMethod: () => import('./BaseFormPaymentMethod'),
  BaseFormPhone: () => import('./BaseFormPhone'),
  BaseFormNip: () => import('./BaseFormNip'),
  BaseFormState: () => import('./BaseFormState'),
  BaseFormCountry: () => import('./BaseFormCountry'),

  /* Grouped */
  BaseFormGroupedCheckbox: () => import('./grouped/BaseFormGroupedCheckbox'),

  /* Custom components for pools */
  BaseFormPoolChildrenArray: () => import('./pool/BaseFormPoolChildrenArray'),

  /* Validators */
  BaseFormValidateGroupedCheckbox: () => import('./validate/BaseFormValidateGroupedCheckbox'),
}
